import axios from 'axios'
import {
    AJOUTER_SOMMAIRE,
    LISTE_SOMMAIRE, LISTE_SOMMAIRE_ACTIVE,  
    MODIFIER_SOMMAIRE,
    MODIFIER_ETAT_SOMMAIRE,  SUPPRIMER_SOMMAIRE
} from '../../api/apiRoute'

export const addSommaire = async (data) => {
    return axios.post(AJOUTER_SOMMAIRE, data).then(res => {
        if (res.status === 200) {
            return res.data
        } else {
            return {
                status: 'error',
                message: "La connexion à internet est instable !"
            }
        }
    }).catch(err => console.log(err))
}

export const updateSommaire = async (data) => {
    return axios.post(MODIFIER_SOMMAIRE, data).then(res => {
        if (res.status === 200) {
            return res.data
        } else {
            return {
                status: 'error',
                message: "La connexion à internet est instable !"
            }
        }
    }).catch(err => console.log(err))
}

export const getListeSommaire = async () => {
    return axios.get(LISTE_SOMMAIRE).then(res => {
        if (res.status === 200) {
            return res.data
        } else {
            return {
                status: 'error',
                message: "La connexion à internet est instable !"
            }
        }
    }).catch(err => console.log(err))
}

export const getListeSommaireActive = async () => {
    return axios.get(LISTE_SOMMAIRE_ACTIVE).then(res => {
        if (res.status === 200) {
            return res.data
        } else {
            return {
                status: 'error',
                message: "La connexion à internet est instable !"
            }
        }
    }).catch(err => console.log(err))
}

export const deleteSommaire = async (data) => {
    return axios.post(SUPPRIMER_SOMMAIRE, data).then(res => {
        if (res.status === 200) {
            return res.data
        } else {
            return {
                status: 'error',
                message: "La connexion à internet est instable !"
            }
        }
    }).catch(err => console.log(err))
}


export const updateEtatSommaire = async (data) => {
    return axios.post(MODIFIER_ETAT_SOMMAIRE, data).then(res => {
        if (res.status === 200) {
            return res.data
        } else {
            return {
                status: 'error',
                message: "La connexion à internet est instable !"
            }
        }
    }).catch(err => console.log(err))
}